import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequireAdmin from './RequireAdmin';
import RequireSuperAdmin from './RequireSuperAdmin';

// Lazy pages (tabs)
const SettingsApp = lazyRetry(() => import('./SettingsApp'));
const AccountTab = lazyRetry(() => import('./tabs/AccountTab'));
const SecurityTab = lazyRetry(() => import('./tabs/SecurityTab'));
const PlanBillingTab = lazyRetry(() => import('./tabs/PlanBillingTab'));
const GroupsTab = lazyRetry(() => import('./tabs/GroupsTab'));
const TeamTab = lazyRetry(() => import('./tabs/TeamTab'));
const TokenUsageTab = lazyRetry(() => import('./tabs/TokenUsageTab'));
const Sector7App = lazyRetry(() => import('../../sector7/Sector7App'));

/**
 * /admin/settings routes
 * SettingsApp renders <Outlet/>, these are its children.
 */
const SettingsAppRoute: FuseRouteItemType = {
  path: 'admin/settings',
  element: <Suspense><SettingsApp /></Suspense>,
  children: [
    { path: '', element: <Suspense><AccountTab /></Suspense> },
    { path: 'account', element: <Suspense><AccountTab /></Suspense> },
    { path: 'security', element: <Suspense><SecurityTab /></Suspense> },
    { path: 'billing', element: <Suspense><PlanBillingTab /></Suspense> },

    // Group membership and permission management is available to tenant admins
    // and SuperAdmins. The API enforces the same role boundary.
    {
      path: 'groups',
      element: (
        <RequireAdmin>
          <Suspense><GroupsTab /></Suspense>
        </RequireAdmin>
      ),
    },
    {
      path: 'team',
      element: (
        <RequireAdmin>
          <Suspense><TeamTab /></Suspense>
        </RequireAdmin>
      ),
    },
    {
      path: 'token-usage',
      element: (
        <RequireSuperAdmin>
          <Suspense><TokenUsageTab /></Suspense>
        </RequireSuperAdmin>
      ),
    },
    {
      path: 'sector7',
      element: (
        <RequireSuperAdmin>
          <Suspense><Sector7App /></Suspense>
        </RequireSuperAdmin>
      ),
    },
    {
      path: 'external-connections',
      element: (
        <RequireSuperAdmin>
          <Navigate replace to="/admin/applications/connections" />
        </RequireSuperAdmin>
      ),
    },
  ],
};

export default SettingsAppRoute;
